(() => {
  const section = /** @type {HTMLElement} */ (document.querySelector('.manuals[data-section-id]'));
  const form = /** @type {HTMLFormElement} */ (document.querySelector('.manuals__search-form'));
  const searchInput = /** @type {HTMLInputElement} */ (document.getElementById('mn-search'));
  const filterSelect = /** @type {HTMLSelectElement} */ (document.getElementById('mn-filter'));
  const resultsEl = /** @type {HTMLElement} */ (document.getElementById('manuals-results'));

  if (!section || !form || !searchInput || !filterSelect || !resultsEl) return;

  const sectionId = section.dataset.sectionId ?? '';
  const baseUrl = window.location.href.split('?')[0] ?? window.location.pathname;
  let currentController = /** @type {AbortController | null} */ (null);

  /** Builds the Shopify search URL for the current form state, or null to show the default collection */
  function buildSearchUrl() {
    const query = searchInput.value.trim();
    const productType = filterSelect.value;

    if (!query && !productType) return null;

    let q = query;
    if (productType) {
      q += (q ? ' ' : '') + `product_type:"${productType}"`;
    }

    return `/search?${new URLSearchParams({ q, type: 'product', manual: 'true' }).toString()}`;
  }

  /** @param {string} url */
  async function fetchSection(url) {
    if (currentController) currentController.abort();
    currentController = new AbortController();

    section.classList.add('manuals--loading');

    try {
      const sep = url.includes('?') ? '&' : '?';
      const response = await fetch(`${url}${sep}sections=${encodeURIComponent(sectionId)}`, {
        signal: currentController.signal,
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const data = await response.json();
      const html = data[sectionId];
      if (!html) throw new Error('Section not in response');

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newResults = doc.getElementById('manuals-results');
      if (newResults) resultsEl.innerHTML = newResults.innerHTML;
    } catch (err) {
      if (/** @type {Error} */ (err).name !== 'AbortError') {
        console.error('[manuals]', err);
      }
    } finally {
      section.classList.remove('manuals--loading');
    }
  }

  // Intercept pagination link clicks inside the results area
  resultsEl.addEventListener('click', (e) => {
    const link = /** @type {Element} */ (e.target).closest('a.pagination__link');
    if (!link) return;
    const href = /** @type {HTMLAnchorElement} */ (link).href;
    if (!href) return;
    e.preventDefault();
    fetchSection(href);
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    fetchSection(buildSearchUrl() ?? baseUrl);
  });

  filterSelect.addEventListener('change', () => {
    fetchSection(buildSearchUrl() ?? baseUrl);
  });
})();
